/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Acceptable_UseInputs */

const en_footer_acceptable_use = /** @type {(inputs: Footer_Acceptable_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptable Use`)
};

const zh_hans1_footer_acceptable_use = /** @type {(inputs: Footer_Acceptable_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可接受使用政策`)
};

const pt_br2_footer_acceptable_use = /** @type {(inputs: Footer_Acceptable_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso Aceitável`)
};

const es_footer_acceptable_use = /** @type {(inputs: Footer_Acceptable_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso aceptable`)
};

const fr_footer_acceptable_use = /** @type {(inputs: Footer_Acceptable_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisation acceptable`)
};

const de_footer_acceptable_use = /** @type {(inputs: Footer_Acceptable_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richtlinie zur akzeptablen Nutzung`)
};

const ru_footer_acceptable_use = /** @type {(inputs: Footer_Acceptable_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Допустимое использование`)
};

const it_footer_acceptable_use = /** @type {(inputs: Footer_Acceptable_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso accettabile`)
};

/**
* | output |
* | --- |
* | "Acceptable Use" |
*
* @param {Footer_Acceptable_UseInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_acceptable_use = /** @type {((inputs?: Footer_Acceptable_UseInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Acceptable_UseInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_acceptable_use(inputs)
	if (locale === "pt-BR") return pt_br2_footer_acceptable_use(inputs)
	if (locale === "es") return es_footer_acceptable_use(inputs)
	if (locale === "fr") return fr_footer_acceptable_use(inputs)
	if (locale === "de") return de_footer_acceptable_use(inputs)
	if (locale === "ru") return ru_footer_acceptable_use(inputs)
	if (locale === "it") return it_footer_acceptable_use(inputs)
	return en_footer_acceptable_use(inputs)
});